<template>
  <div class="company--contacts-tab--details">
    <form @submit="submit" method="post" class="mt-3">

      <b-card v-if='!buttonsHeaderVisible' class="buttonHeader">
        <b-row>
          <b-button @click="cancel" type="button" class="btn btn-secondary cancelButton" size="sm">
            Cancel
          </b-button>
          <b-button variant="primary" type="submit" class="btn btn-primary" size="sm" :disabled="isSaving">
            <i v-if="isSaving" class="fa fa-spinner fa-pulse fa-fw mr-1"></i>Save
          </b-button>
        </b-row>
      </b-card>

      <b-row>
        <b-col cols="6">

          <b-row class="d-flex justify-content-between mr-2 mb-2">
            
            <h4 class="contact--title">Personal info</h4>
            
            <b-form-checkbox class="mt-2" v-model="contact.isPrimary">Primary Contact</b-form-checkbox>

            <div id="buttonHeader">
              <b-button size="sm" variant="primary" class="btn btn-primary mr-2" @click="openTodoModal">
                <i class="fa fa-plus" aria-hidden="true"></i> Add Task
              </b-button>
              <b-button @click="cancel" class="btn btn-secondary mr-1" size="sm">
                Cancel
              </b-button>
              <b-button variant="primary" type="submit" class="btn btn-primary ml-1" size="sm" :disabled="isSaving">
                <i v-if="isSaving" class="fa fa-spinner fa-pulse fa-fw mr-1"></i>Save
              </b-button>
            </div>

          </b-row>

          <b-row>
            <b-col cols="4">

              <b-form-group class="required" label="First name">
                <b-form-input :class="{ 'is-invalid': $v.contact.firstName.$error }"
                  @blur="$v.contact.firstName.$touch()" v-model.trim="contact.firstName"></b-form-input>
                <div class="invalid-feedback">First name is required</div>
              </b-form-group>

              <b-form-group class="required" label="Last name">
                <b-form-input :class="{ 'is-invalid': $v.contact.lastName.$error }" @blur="$v.contact.lastName.$touch()"
                  v-model.trim="contact.lastName"></b-form-input>
                <div class="invalid-feedback">Last name is required</div>
              </b-form-group>

              <b-form-group label="Title">
                <b-form-input v-model.trim="contact.title"></b-form-input>
              </b-form-group>

              <b-form-group label="Main">
                <b-form-input v-model.trim="company.phone1" disabled></b-form-input>
              </b-form-group>

            </b-col>

            <b-col cols="4">

              <b-form-group label="Gender">
                <b-form-select v-model="contact.gender" :options="genderOptions" />
              </b-form-group>

              <b-form-group label="Date of birth">
                <date-picker v-model="contact.dob" :config="datePickerOptions"></date-picker>
              </b-form-group>

              <b-form-group label="Location">
                <b-form-input v-model.trim="contact.location"></b-form-input>
              </b-form-group>

              <b-form-group label="Location Phone">
                <b-form-input v-model.trim="contact.locationPhone"></b-form-input>
              </b-form-group>

            </b-col>

            <b-col cols="4">

              <b-form-group label="LinkedIn">
                <b-form-input v-model.trim="contact.linkin"></b-form-input>
              </b-form-group>


              <b-form-group label="Skype">
                <b-form-input v-model.trim="contact.skype"></b-form-input>
              </b-form-group>


              <b-form-group label="Twitter">
                <b-form-input v-model.trim="contact.twitter"></b-form-input>
              </b-form-group>

            </b-col>
            
            <b-col cols="8">

              <b-form-group label="Direct" class="phone-input">
                <b-form-input :class="{ 'is-invalid': $v.contact.phone1.$error }" @blur="$v.contact.phone1.$touch()"
                  v-model.trim="contact.phone1"></b-form-input>
                <div class="invalid-feedback">Invalid phone number</div>
              </b-form-group>
              <b-form-group label="Extension">
                <b-form-input :class="{ 'is-invalid': $v.contact.phone1Ext.$error }"
                  @blur="$v.contact.phone1Ext.$touch()" v-model.trim="contact.phone1Ext"></b-form-input>
                <div class="invalid-feedback">Invalid extension</div>
              </b-form-group>
              <!-- <b-form-group class="phone-type-input">
                <b-form-select v-model="contact.phone1TypeId" :plain="true">
                  <option v-for="(type) in sortSelect(phoneTypes)" :key="type.id" :value="type.id">{{type.name}}</option>
                </b-form-select>
              </b-form-group> -->
              <b-form-group label="Mobile" class="phone-input">
                <b-form-input :class="{ 'is-invalid': $v.contact.phone2.$error }" @blur="$v.contact.phone2.$touch()"
                  v-model.trim="contact.phone2"></b-form-input>
                <div class="invalid-feedback">Invalid phone number</div>
              </b-form-group>

              <b-form-group label="Extension">
                <b-form-input :class="{ 'is-invalid': $v.contact.phone2Ext.$error }"
                  @blur="$v.contact.phone2Ext.$touch()" v-model.trim="contact.phone2Ext"></b-form-input>
                <div class="invalid-feedback">Invalid extension</div>
              </b-form-group>
              <!-- <b-form-group class="phone-type-input">
                <b-form-select v-model="contact.phone2TypeId" :plain="true">
                  <option v-for="(type) in sortSelect(phoneTypes)" :key="type.id" :value="type.id">{{type.name}}</option>
                </b-form-select>
                <b-form-checkbox class="mt-2" v-model="contact.doNotCall">Do not call</b-form-checkbox>
              </b-form-group> -->
              <b-form-group label="Email">
                <b-form-input :class="{ 'is-invalid': $v.contact.email1.$error }" @blur="$v.contact.email1.$touch()"
                  v-model.trim="contact.email1"></b-form-input>
                <div class="invalid-feedback">Invalid email format</div>
                <b-form-checkbox class="mt-2" v-model="contact.doNotEmail">Do not email</b-form-checkbox>
              </b-form-group>

            </b-col>

            <b-col cols="4">

              <b-form-group label="Facebook">
                <b-form-input v-model.trim="contact.facebook"></b-form-input>
              </b-form-group>

              <b-form-group label="Xing">
                <b-form-input v-model.trim="contact.xing"></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>

          <required-descriptor />

          <div class="clearfix"></div>
        </b-col>

        <b-col cols="4">
          <notes :notes="notes" @add="handleAddNote" @edit="handleUpdateNote" @delete="handleDeleteNote" />
        </b-col>
      </b-row>
    </form>
    <add-task :editDetails="taskDetails" fromCompanyPage />
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import { required } from 'vuelidate/lib/validators';
  import moment from 'moment';

  import { DATE_FORMAT } from '@/shared/constants';

  import contactService from '@/resources/ContactService';
  import { phoneValidator, emailValidator } from '@/shared/validators';

  import { createScroll, destroyScroll, isElementInView } from '@/shared/scroll'
  import AddTask from '@/pages/Todotasks/components/add';

  export default {
    name: 'ContactTabDetails',
    components: {
      AddTask
    },
    data() {
      return {
        notes: [],
        message: '',
        contact: {
          firstName: '',
          lastName: '',
        },
        newNoteMessage: '',
        originalContact: {},
        phoneTypes: [],
        genderOptions: [
          { value: 'F', text: 'Female' },
          { value: 'M', text: 'Male' },
        ],
        datePickerOptions: {
          format: DATE_FORMAT,
          useCurrent: false,
        },
        buttonsHeaderVisible: true,
        isSaving:false,
        taskDetails: {}
      };
    },
    metaInfo: function () {
      return {
        title: `${this.contact.firstName} ${this.contact.lastName} - ${this.company.name}`,
      }
    },
    computed: {
      ...mapGetters('companies', ['companyById']),
      company() {
        return this.companyById(this.companyId);
      },
      companyId() {
        return this.$route.params.id;
      },
      contactId() {
        return this.$route.params.contactId;
      },
    },
    validations: {
      contact: {
        firstName: { required },
        lastName: { required },
        phone1: { phoneValidator },
        phone1Ext: { phoneValidator },
        phone2: { phoneValidator },
        phone2Ext: { phoneValidator },
        email1: { emailValidator },
      },
    },
    methods: {
      reloadContact() {
        contactService.getOne(this.$route.params.contactId).then(contact => {
          this.contact = Object.assign({}, contact);
          this.originalContact = Object.assign({}, contact);
        });
      },
      async getPhoneTypes() {
        this.phoneTypes = await contactService.getPhoneTypes();
      },

      async submit(e) {
        e.preventDefault();
        this.$v.$touch();
        if (this.$v.$invalid) {
          return;
        }
        try {
          this.isSaving = true;
          await contactService.update(this.contact).then(() => {
            this.$snotify.success('Contact updated', 'Contact');
          });
          this.originalContact = Object.assign({}, this.contact);
          this.$v.$reset();
          this.isSaving = false;
          this.$emit('contact', this.originalContact);
        } catch (e) {
          this.isSaving = false;
          /*console.log(e.message);*/
        }
      },
      reset(e) {
        e.preventDefault();
        this.contact = Object.assign({}, this.originalContact);
        this.$v.$reset();
      },
      cancel() {
        this.$router.push({path: `/company/${this.companyId}/contacts`});
      },
      async loadNotes() {
        this.notes = await contactService.getAllNotes(this.contactId);
      },
      async handleAddNote(note) {
        await contactService.createNote(this.contactId, note);
        await this.loadNotes();
        this.$snotify.success('New note added', 'Contact Note');
      },
      async handleUpdateNote(note) {
        await contactService.updateNote(note.id, note);
        await this.loadNotes();
        this.$snotify.success('Note updated', 'Contact Note');
      },
      async handleDeleteNote(note) {
        await contactService.deleteNote(note);
        await this.loadNotes();
        this.$snotify.success('Note deleted', 'Contact Note');
      },
      handleScroll() {
        this.buttonsHeaderVisible = isElementInView(document.getElementById('buttonHeader'));
      },
      openTodoModal() {
        this.taskDetails = {};
        this.taskDetails.companyId = this.companyId;
        this.taskDetails.companyName = this.company.name;
        this.taskDetails.contactId = this.contactId;
        this.taskDetails.assignedToUserId = this.company.salesPerson1UserId;

        console.log(this.taskDetails, 'Task Details')
        this.$bvModal.show('add-task-modal');
      },
    },
    watch: {
      'contact.dob'() {
        console.log("this.contact.dob:");
        console.log(this.contact.dob);
        if (this.contact.dob != undefined && this.contact.dob != null && this.contact.dob != '')
          this.contact.dob = moment(this.contact.dob).format(DATE_FORMAT);
        //if (this.contact.dob = "Invalid date") this.contact.dob = null;
      },
    },
    async mounted() {
      await this.loadNotes();
      await this.getPhoneTypes();
      await this.reloadContact();
    },
    created() {
      createScroll(this);
    },
    destroyed() {
      destroyScroll(this);
    },
  };
</script>

<style lang="scss" scoped>
  @import '@/assets/scss/_colors.scss';

  .phone-input {
    width: 70%;
    float: left;
    margin-right: 5px;
  }

  .phone-type-input {
    width: 100%;
  }

  .contact {
    &--title {
      color: $mutedGray;
      font-weight: bold;
      font-size: 16px;
      margin-left: 15px;
    }
  }

  .buttonHeader {
    position: fixed;
    top: 15%;
    left: 50%;
    z-index: 7;
  }

  .cancelButton {
    margin-right: 10px;
  }
</style>
